import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  //所有的数据都放在state中
  state: {
    /* 聊天类型 */
    chatType: "",
    /* 记录登录状态 */
    isLogin: false,
    /* 别人的信息（特指聊天对象） */
    userInfo: {
      img: "",
      name: "",
    },
    /* 聊天记录 */
    chatMessageList: {},
    doctorEmployeeNote: "",
    surrferId: "",
    orderNumber: "",
    orderDrugList: {},
    recordData: {},
    StatusFlag: false,
    showMsgFlag: false,
    CF_Flag: false,
    setScrollFlag: 0,
    loadFlag: false,
    count: 0,
    getImg: "",
    cover: "",
    sendImg:"",
    opspInfo: {
      diseCode: '',
      diseName: '',
      medType: '',
    },
  },

  //操作数据，唯一的通道是mutations
  mutations: {
    /* 聊天记录的修改,这里我们使用vuex监听 */
    SOCKET_updateChatMessageList(state, data) {
      state.chatMessageList = data;
    },
    /* 修改聊天类型 */
    changeChatType(state, data) {
      state.chatType = data;
    },
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    SET_DOCTOREMPLOYEENOTE(state, data) {
      state.doctorEmployeeNote = data;
    },
    SET_SURRFERID(state, data) {
      state.surrferId = data;
    },
    SET_ORDERNUMBER(state, data) {
      state.orderNumber = data;
    },
    SET_ORDERDRUGLIST(state, data) {
      state.orderDrugList = data;
    },
    SET_RECORDDATA(state, data) {
      state.recordData = data;
    },
    SET_STATUSFLAG(state, data) {
      state.StatusFlag = data;
    },
    SET_SHOWMSGFLAG(state, data) {
      state.showMsgFlag = data;
    },
    SET_CF_FLAG(state, data) {
      state.CF_Flag = data;
    },
    SET_SCORLLFLAG(state, data) {
      state.setScrollFlag = data;
    },
    SET_LOAD_FLAG(state, data) {
      state.loadFlag = data;
    },
    SET_COUNT(state, data) {
      state.count = data;
    },
    SET_GETIMG(state, data) {
      state.getImg = data;
    },
    SET_COVER(state, data) {
      state.cover = data;
    },
    SET_SENDIMG(state,data){
        state.sendImg = data;
    },
    /* 设置慢特病信息 */
    SET_OPSPINFO(state, data) {
      state.opspInfo = data;
    }
  },

  //actions,可以来做异步操作，然后提交给mutations，而后再对state(数据)进行操作
  actions: {},
});
